import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import {
  selectDrawDetail,
  hideDrawModal
} from "../../../state/ducks/member/index";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: '0px'
  }
};

Modal.setAppElement("#app");

class DrawDetail extends Component {
  hideModal = () => {
    this.props.hideDrawModal();
  };

  render() {
    const { drawDetail } = this.props;
    return (
      <Modal
        isOpen={drawDetail?.drawIsOpen}
        onRequestClose={this.closeModal}
        style={{
          overlay: {
            position: 'fixed',
            inset: "0% 0% 0% 0%",
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.4)'
          },
          content: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            top: 0,
            left: 0,
            border: '0px',
            backgroundColor: 'transparent' /* Black w/ opacity */

          }
        }}
      
      >
       <div className="t-modalArea" id="id-modal" style={{ display: "block" }}>
  {/* Bu kısım animasyon için Hareket eden kısım. */}
  <div className="t-modalContent" id="id-modalTipi" style={(window.innerWidth<=900)?{width:"89%"}: {width:"50%"}}>
    <div
      className="t-modal"
      id="id-modalGenel"
      style={{ backgroundColor: "rgb(255, 255, 255)" }}
    >
      <div className="container-fluid">
        {/* Header */}
        <div className="row t-modalHeader">
          <div
            className="col"
            id="id-modalHeader"
            style={{ color: "rgb(153, 153, 153)" }}
          >
            Çekiliş Tarihi : {new Date(this.props.cekilisTarihi).toLocaleDateString()}
          </div>
          <div className="col-auto t-cursorPointer"  onClick={() => this.hideModal()}>
            <i
              className="t-icon-cross"
              id="id-modalHeaderIcon"
              style={{ color: "rgb(153, 153, 153)" }}
            />
          </div>
        </div>
        {/* Body */}
        <div className="row t-modalBody">
          <div
            className="col-12"
            id="id-modalBody"
            style={{ color: "rgb(153, 153, 153)" }}
          >
            <table className="table table-sm t-tablo">
              <thead>
                <tr>
                  <th scope="col">Talihli Adı Soyadı</th>
                  <th scope="col">Çekiliş Belirleme Tarihi</th>
                  <th scope="col">Planlanan Teslim Tarihi</th>
                </tr>
              </thead>
              <tbody>
              {drawDetail?.drawDetail &&
                  drawDetail.drawDetail.map(item => {
                    return (
                      <tr key={item.id}>
                        <td>{item.unvan}</td>
                        <td>{item.teslimatTarihi}</td>
                        <td>{item.planlananTeslimatTarihi}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
        {/* footer*/}
        <div className="row t-modalFooter">
          <div
            className="col-12"
            id="id-modalFooter"
            style={{ color: "rgb(153, 153, 153)" }}
          />
        </div>
      </div>
    </div>
  </div>
</div>

      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    drawDetail: selectDrawDetail(state)
  };
};

const mapDispatchToProps = dispatch => ({
  hideDrawModal: () => dispatch(hideDrawModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(DrawDetail);
